const axios = require('axios'),
      {name, version} = require('../package');

const {UnifiedFormData, userAgent} = (() => {
  try{
    return {UnifiedFormData: FormData, userAgent: {}};
  }catch(err){
    return {UnifiedFormData: require('form-data'), userAgent: {'User-Agent': `${name}/${version}`}};
  }
})();

const requestHeaders = {
  ...userAgent, 'Content-Type': 'application/json'
};

const where = {

  ...require('./where'),

  client: (config, option = {}) => {

    const client = {

      url: (table, path) => {
        const url = config.url.replace(/\/$/, '');

        path = (!path) ? '' : path.replace(
          /^\/(.*)\/$/, '$1').split(/\\\//).map((v) => (encodeURI(v))).join('%2F');

        return [url, table, path].join('/');
      },

      login: async (user, password, passcode) => {

        const headers = {...requestHeaders};

        try{
          const {data: res} = await axios.post(config.url, {user, password, passcode}, {headers});

          requestHeaders['Authorization'] = `Bearer ${res.accessToken}`;
          return res;

        }catch(err){
          throw new Error((err.response && err.response.status) ? err.response.status : err.message);
        }
      },

      refresh: async (accessToken, refreshToken) => {

        const headers = {...requestHeaders};

        try{
          const {data: res} = await axios.put(config.url, {accessToken, refreshToken}, {headers});

          requestHeaders['Authorization'] = `Bearer ${res.accessToken}`;
          return res;

        }catch(err){
          throw new Error((err.response && err.response.status) ? err.response.status : err.message);
        }
      },

      get: async (table, condition) => {

        const headers = {...requestHeaders};

        if(condition && typeof condition !== 'string'){
          condition = where.cq.stringify(condition);
        }

        try{
          const {data: res} = await axios.get(client.url(table, condition), {headers, data: {}});
          return res;

        }catch(err){
          throw new Error((err.response && err.response.status) ? err.response.status : err.message);
        }

      },

      post: async (table, data, files) => {

        const formData = new UnifiedFormData();

        ((Array.isArray(data)) ? data : [data]).forEach(v => {
           Object.entries(v).forEach(([k, v]) => {
             try{
                formData.append(k, (v.match(/^([1-9]\d*|0)(\.\d+)?$/)) ? Number(v) : v);

              }catch(err){
                formData.append(k, v);
              }
           });
        });

        try{
          if(files && files.length){
            [...files].forEach(v => {
              formData.append('files', ...(Array.isArray(v) ? v : [v]));
            });
          }

          const headers = (!formData.getHeaders) ? {...requestHeaders} : Object.entries(formData.getHeaders()).reduce((o, [k, v]) => {
            return {...o, [k]: v};
          }, {...requestHeaders});

          const {data: res} = await axios.post(client.url(table), formData, {headers, ...option});
          return res;

        }catch(err){
          throw new Error((err.response && err.response.status) ? err.response.status : err.message);
        }

      },

      put: async (table, data, condition, files) => {

        if(condition && typeof condition !== 'string'){
          condition = where.cq.stringify(condition);
        }

        const formData = new UnifiedFormData();

        ((Array.isArray(data)) ? data : [data]).forEach(v => {
           Object.entries(v).forEach(([k, v]) => {
             try{
               formData.append(k, (v.match(/^([1-9]\d*|0)(\.\d+)?$/)) ? Number(v) : v);

              }catch(err){
                formData.append(k, v);
              }
           });
        });

        try{
          if(files && files.length){
            [...files].forEach(v => {
              formData.append('file', ...(Array.isArray(v) ? v : [v]));
            });
          }

          const headers = (!formData.getHeaders) ? {...requestHeaders} : Object.entries(formData.getHeaders()).reduce((o, [k, v]) => {
            return {...o, [k]: v};
          }, {...requestHeaders});

          const {data: res} = await axios.put(client.url(table, condition), formData, {headers, ...option});
          return res;

        }catch(err){
          throw new Error((err.response && err.response.status) ? err.response.status : err.message);
        }

      },

      delete: async (table, condition) => {

        const headers = {...requestHeaders};

        if(condition && typeof condition !== 'string'){
          condition = where.cq.stringify(condition);
        }

        try{
          const {data: res} = await axios.delete(client.url(table, condition), {headers});
          return res;

        }catch(err){
          throw new Error((err.response && err.response.status) ? err.response.status : err.message);
        }
      }
    };

    if(![null, undefined].includes(config.accessToken)){
      requestHeaders['Authorization'] = `Bearer ${config.accessToken}`;
    }

    return client;
  }
};

module.exports = where;
